import { Stock as StockDto } from "../../../app/proxy/stocks";

export class Stock {
  balance: number;
  warehouseId: number;
  productId: number;

  constructor(dto: StockDto) {
    Object.assign(this, dto);
  }
}